import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import HeaderIcon from '../../images/pre-book/PrebookModalHeaderImage.png';
import StarIcon from '../../images/pre-book/PrebookModalHeaderStar.svg';
import ModalBackground from '../../images/pre-book/ModalBg.svg';
import { PrimaryButton } from '../common/Buttons';
import { ButtonText } from '../common/Text';
import Cross from '../../images/pre-book/white-cross.svg';
import { getPrebookSteps, getRelatives } from '../../services';
import { useSelector } from 'react-redux';
import LoadingComponent from '../common/LoadingComponent';
import { useHistory } from 'react-router-dom';
import Modal from '../../containers/common/Modal';
import { FlyInTransition } from '../transitions/transitions';
import profile from '../../images/common/new_profile.svg';
import StyledTappable from '../common/StyledTappable';
import { logEvent } from '../../utils/logEvent';

const OuterContainer = styled.div`
  background-image: url(${ModalBackground});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 12px;
`;
const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 0px 20px;
  width: 100%;
  gap: 50px;
`;

const Text1 = styled.div`
  font-size: 16px;
  font-weight: 800;
  line-height: 22.4px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #fff;
`;
const Text2 = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0.28673017024993896px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #fff;
  margin-top: 10px;
`;
const HeaderImg = styled.img`
  height: 100px;
  width: 100x;
  margin-right: 20px;
`;
const CrossIcon = styled.img`
  top: -10px;
  right: -11px;
  position: absolute;
`;
const Star1 = styled.img`
  top: -14px;
  left: -37px;
  position: absolute;
`;
const Star2 = styled.img`
  right: 1px;
  top: 70px;
  position: absolute;
`;

const BodyContainer = styled.div`
  padding: 0px 20px 20px 20px;
  overflow-y: auto; /* Enable vertical scroll */
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
  flex: 1;
  height: 280px;
`;

const IntroDetailsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0px 2px 12px 0px #0000001f;
  margin-top: 20px;
`;

const IntoImages = styled.img`
  height: 70px;
  width: 70px;
  display: flex;
  align-items: start;
  justify-content: start;
  margin-left: ${(props) => (props.marginLeft ? '5px' : '0px')};
`;

const Title = styled.div`
  font-size: 10px;
  font-weight: 600;
  line-height: 14px;
  letter-spacing: 0.25px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #a5a6bb;
`;

const Desc = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 19.6px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #0f0b28;
  padding-right: 10px;
`;

const FooterContainer = styled.div`
  border-radius: 24px 24px 0px 0px;
  opacity: 0px;
  background: #ffffff;
  box-shadow: -4px 0px 16px 0px #0000001f;
  padding: 20px;
`;

const FooterHeader = styled.div`
  font-size: 12px;
  font-weight: 600;
  line-height: 16.8px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #eb6c46;
`;

const FooterContainerInner = styled.div`
  display: flex;
  align-items: start;
  gap: 10px;
`;

const FooterBullet = styled.div`
  width: 10px;
  height: 10px;
  background: linear-gradient(259.87deg, #ffab47 16.77%, #ff6131 118.37%);
  border-radius: 50%;
  margin-top: 15px;
  flex-shrink: 0;
`;

const FooterPoints = styled.div`
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: linear-gradient(0deg, #0f0b28, #0f0b28),
    linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
    linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
  border-bottom: 1px solid #e3e3e3;
  padding: 10px 0px;
`;

const ButtonContainer = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: ${(props) => (props.phone ? '#EDF9F3' : '#F7FAFF')};
  border-radius: 12px;
  border: 1px solid ${(props) => (props.phone ? '#1EB86533' : '#3F8CFF33')};

  font-size: 14px;
  font-weight: 600;
  line-height: 19.6px;
  letter-spacing: 0.25px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: ${(props) => (props.phone ? '#1EB865' : '#3F8CFF')};
  padding: 10px 16px;
  width: 40%;
  text-wrap: nowrap;
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: white;
  overflow: hidden;
  height: 100%;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
`;
const ScreenIcon = styled.img`
  max-width: 4.265rem;
  font-size: ${() => `${1 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
`;

const CloseContainer = styled(StyledTappable)`
  align-self: flex-end;
  padding: 0.5rem;
`;

const AddedContainer = styled.div`
  width: 18px;
  height: 18px;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  background: #714fff;
  border: 2px solid #714fff;
  border-radius: 50%;
`;

const AddText = styled.div`
  color: #714fff;
  height: 10px;
  width: 10px;
`;

const AddContainer = styled.div`
  width: 18px;
  height: 18px;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  border: 2px solid #714fff;
  border-radius: 50%;
`;

const NextButton = styled(PrimaryButton)`
  margin: 2rem auto 1rem auto;
  width: 95%;
  text-align: center;
  font-weight: 700;
  font-size: 0.875rem;
`;

export default function PreBookStepsModal({
  onClose,
  openProfileId,
  specialistDetails,
  lat,
  long,
  illnessId,
  onClickCrossCta,
}) {
  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(true);
  const [introDetails, setIntroDetails] = useState([]);
  const [footerDetails, setFooterDetails] = useState([]);
  const [centerInfo, setCenterInfo] = useState([]);

  useEffect(() => {
    onClickYOuBookWePayBanner();
    logEvent('Doctor specific bottom sheet opened');
  }, []);

  const onClickYOuBookWePayBanner = () => {
    const doctorHash = openProfileId;
    getPrebookSteps(user?.authToken, doctorHash, true).then((res) => {
      setIntroDetails(res?.introScreens);
      setFooterDetails(res?.footer);
      setCenterInfo(res?.centerInfo);
      setLoading(false);
    });
  };

  console.log('centerInfo', centerInfo);

  return loading ? (
    <LoadingComponent />
  ) : (
    <OuterContainer>
      <HeaderContainer>
        <div>
          <Text1>You Book, We Pay!</Text1>
          <Text2>Book directly with the centre, we’ll pay your bill</Text2>
        </div>
        <div className="relative" style={{ width: '70%' }}>
          <HeaderImg src={HeaderIcon} alt="HeaderImage" />
          <CrossIcon
            src={Cross}
            alt="Close"
            onClick={onClickCrossCta}
            className="absolute"
          />
          <Star1 src={StarIcon} alt="StarIcon" />
          <Star2 src={StarIcon} alt="StarIcon" />
        </div>
      </HeaderContainer>
      <BodyContainer>
        {introDetails?.map((detail) => {
          return (
            <>
              <IntroDetailsContainer>
                <div className="flex items-center gap-8px w-full">
                  <div style={{ flexShrink: 0 }}>
                    <IntoImages
                      src={detail.image_url}
                      alt={detail?.title}
                      marginLeft={detail.title === introDetails[2].title}
                    />
                  </div>
                  <div className="flex flex-col gap-4px">
                    <Title>{detail?.title}</Title>
                    <Desc>{detail?.description}</Desc>
                  </div>
                </div>
                {detail?.button && (
                  <div className="flex items-center gap-10px mb-16px ml-40px w-full mt-16px">
                    {centerInfo?.prebookCenterNumber && (
                      <ButtonContainer
                        phone={true}
                        onClick={() =>
                          logEvent('Call Center tapped (bottom sheet')
                        }
                        href={`tel:${centerInfo?.prebookCenterNumber}`}
                      >
                        <img
                          src={detail?.button[0]?.icon}
                          alt={detail?.button[0]?.text}
                        />
                        <div>{detail?.button[0]?.text}</div>
                      </ButtonContainer>
                    )}
                    {centerInfo?.centerUrl && (
                      <ButtonContainer
                        phone={false}
                        onClick={() =>
                          logEvent('Go to website tapped (bottom sheet)')
                        }
                        href={centerInfo?.centerUrl}
                        target="_blank"
                      >
                        <img
                          src={detail?.button[1]?.icon}
                          alt={detail?.button[1]?.text}
                        />
                        <div>{detail?.button[1]?.text}</div>
                      </ButtonContainer>
                    )}
                  </div>
                )}
              </IntroDetailsContainer>
            </>
          );
        })}
      </BodyContainer>
      <FooterContainer>
        <FooterHeader>{footerDetails?.header}</FooterHeader>
        <FooterPoints>
          {footerDetails?.text?.map((i) => (
            <FooterContainerInner>
              <FooterBullet />
              <div className="mt-8px">{i}</div>
            </FooterContainerInner>
          ))}
        </FooterPoints>
        <PrimaryButton onTap={onClose}>
          <ButtonText>{footerDetails?.buttonText}</ButtonText>
        </PrimaryButton>
      </FooterContainer>
    </OuterContainer>
  );
}
